import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CONSTANTS } from '../../data';

interface EnvironmentalMessageProps {
  message: {
    text: string;
    effectClass: string;
  } | null;
  onComplete: () => void;
}

export const EnvironmentalMessage: React.FC<EnvironmentalMessageProps> = ({ message, onComplete }) => {
  const [position, setPosition] = useState({ top: '50%', left: '50%' });

  useEffect(() => {
    if (message) {
      setPosition({
        top: `${20 + Math.random() * 60}%`,
        left: `${10 + Math.random() * 80}%`,
      });

      const timer = setTimeout(() => {
        onComplete();
      }, CONSTANTS.ENVIRONMENTAL_HORROR.displayDurationMs);

      return () => clearTimeout(timer);
    }
  }, [message, onComplete]);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          className={`env-message ${message.effectClass || ''}`}
          style={{
            top: position.top,
            left: position.left,
            transform: 'translateX(-50%)',
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
        >
          {message.text}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
